import Icon from '../components/Icon.vue'

Icon.register({
  'draw-polygon': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M384 352C383.6 352 383.3 352.1 383 352.1L343.8 286.8C348.9 277.6 352 267.2 352 256S348.9 234.4 343.8 225.2L383 159.9C383.3 159.9 383.7 160 384 160 419.4 160 448 131.4 448 96S419.4 32 384 32C360.4 32 340 44.9 328.9 64H119.1C108 44.9 87.6 32 64 32 28.6 32 0 60.6 0 96 0 119.6 12.9 140 32 151.1V360.9C12.9 372 0 392.4 0 416 0 451.4 28.6 480 64 480 87.6 480 108 467.1 119.1 448H328.9C340 467.1 360.4 480 384 480 419.3 480 448 451.4 448 416 448 380.6 419.4 352 384 352zM96 360.9V151.1A63.8-63.8 0 0 1 119.1 128H327.5L289 192.1C288.7 192.1 288.4 192 288 192 252.7 192 224 220.7 224 256S252.7 320 288 320C288.4 320 288.7 319.9 289 319.9L327.5 384H119.1A63.7-63.7 0 0 1 96 360.9zM272 256C272 247.2 279.2 240 288 240S304 247.2 304 256 296.8 272 288 272 272 264.8 272 256zM400 96C400 104.8 392.8 112 384 112S368 104.8 368 96 375.2 80 384 80 400 87.2 400 96zM64 80C72.8 80 80 87.2 80 96S72.8 112 64 112 48 104.8 48 96 55.2 80 64 80zM48 416C48 407.2 55.2 400 64 400S80 407.2 80 416 72.8 432 64 432 48 424.8 48 416zM384 432C375.2 432 368 424.8 368 416S375.2 400 384 400 400 407.2 400 416 392.8 432 384 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/draw-polygon.js
// module id = gyAu
// module chunks = 144